export const getOffCanvasPanelClasses = (isSmallScreen: boolean) => {
  const smallScreenClasses =
    'overflow-hidden relative overscroll-contain flex flex-col z-10 top-unset bottom-0 transform rounded-b-none md:rounded-b-2xl max-md:max-h-[88vh] max-md:min-h-[88vh] rounded-2xl bg-white text-left shadow-xl transition-all w-full';
  // Sticky in a column as tall as its container (see JxtOffCanvas): it stays under the navbar while
  // the page scrolls, its own content scrolling only when scrolled in.
  const desktopClasses =
    'pointer-events-auto sticky w-full border-l overflow-hidden overscroll-contain border-neutral-20 shadow-elevation-3 bg-white flex flex-col';

  return { classes: isSmallScreen ? smallScreenClasses : desktopClasses };
};
